import React from 'react'
import PropTypes from 'prop-types'
import Image from '../../../shared/Image'
import Link from '../../../shared/Link'
import { Wrapper } from '../../Container/Container.style'
import { DynamicGridWrapper } from './DynamicGrid.style'
import { PrimaryButton, ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
import ArrowRight from '../Icons/ArrowRight'

export default function DynamicGrid({ title, textImageWithCta }) {
  return (
    <Wrapper>
      <DynamicGridWrapper className="wow fadeIn">
        <h3>{title}</h3>
        <div className="grid-container">
          {textImageWithCta.length > 1 ? (
            textImageWithCta.map(item => {
              return (
                <div className="grid-item" key={item.id}>
                  <div>
                    <Image
                      src={item.image.imageFile.file.url}
                      alt={item.image.altText}
                    />
                    <div className="description">
                      <h4>{item.title}</h4>
                      {item.description && (
                        <div
                          className="productDescription"
                          dangerouslySetInnerHTML={{
                            __html: item.description.childMarkdownRemark.html,
                          }}
                        />
                      )}
                    </div>
                  </div>
                  { item.ctaLabel && (
                    <PrimaryButton>
                      <Link to={item.url}>
                        {item.ctaLabel}
                        <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
                      </Link>
                    </PrimaryButton>
                  )}
                </div>
              )
            })
          ) : (
            <div key={textImageWithCta[0].id} className="dynamicGrid">
              <Image
                src={textImageWithCta[0].image.imageFile.file.url}
                alt={textImageWithCta[0].image.altText}
              />
              <div className="description">
                <h4>{textImageWithCta[0].title}</h4>
                {textImageWithCta[0].description && (
                  <div
                    className="productDescription"
                    dangerouslySetInnerHTML={{
                      __html:
                      textImageWithCta[0].description.childMarkdownRemark
                        .html,
                    }}
                  />
                )}
                {textImageWithCta[0].ctaLabel && (
                  <PrimaryButton>
                    <Link to={textImageWithCta[0].url}>
                      {textImageWithCta[0].ctaLabel}
                      <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
                    </Link>
                  </PrimaryButton>
                )}
              </div>
            </div>
          )}
        </div>
      </DynamicGridWrapper>
    </Wrapper>
  )
}

DynamicGrid.propTypes = {
  title: PropTypes.string.isRequired,

  textImageWithCta: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    ctaLabel: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
      altText: PropTypes.string.isRequired,
      imageFile: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }),
      }),
    }),
    description: PropTypes.shape({
      childMarkdownRemark: PropTypes.shape({
        html: PropTypes.string,
      }),
    }),
  })).isRequired,
}
